import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import { Play } from "lucide-react";
import "swiper/css";
import "swiper/css/navigation";
import styles from "./Css/AudioSeries.module.css";
import { useHomeTrendingSeries } from "../../hooks/useHomePageHooks";

const AudioSeries = () => {
  const navigate = useNavigate();
  const { trendingSeries, isLoading } = useHomeTrendingSeries();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Audio Series</h2>
      </div>

      {isLoading ? (
        <div className={styles.loadingContainer}>
          <p>Loading audio series...</p>
        </div>
      ) : (
        <Swiper
          modules={[Mousewheel, FreeMode]}
          freeMode={{
            enabled: true,
            momentum: true,
            momentumRatio: 1, // smoother momentum
            momentumVelocityRatio: 1, // normal velocity handling
            minimumVelocity: 0.02, // keep this small to allow tiny moves
          }}
          spaceBetween={20}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 0.5, // Lower sensitivity for smoother movement
            releaseOnEdges: true,
          }}
          speed={400} // Reduce speed slightly for softer acceleration
          resistance={true} // Allow a bit of resistance (helps feel natural)
          resistanceRatio={0.85}
          slidesPerView={2}
          className={styles.swiperCard}
          breakpoints={{
            0: {
              slidesPerView: 1.6,
              spaceBetween: 8,
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 2.5,
              spaceBetween: 12,
            },
            1440: {
              slidesPerView: 3,
              spaceBetween: 15,
            },
          }}
        >
          {trendingSeries && trendingSeries.length > 0 ? (
            trendingSeries.map((item) => (
              <SwiperSlide key={item.id}>
                <div className={styles.cardContainer}>
                  <div
                    className={styles.card}
                    onClick={() =>
                      navigate(`/audio-play/${item?.first_audio?.slug}`)
                    }
                  >
                    <img
                      src={
                        item.cover_image_url ||
                        item.first_audio?.computer_image_url
                      }
                      alt={item.title}
                      loading="lazy"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/default-image.jpg";
                      }}
                    />
                    <div className={styles.cardContent}>
                      
                      <button
                        className={styles.listenButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/audio-play/${item?.first_audio?.slug}`);
                        }}
                      >
                        <Play size={16} />
                        Listen Now
                      </button>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))
          ) : (
            <SwiperSlide>
              <div className={styles.noContentMessage}>
                No audio series available.
              </div>
            </SwiperSlide>
          )}
        </Swiper>
      )}
    </div>
  );
};

export default AudioSeries;
